import { CircleCheck, CircleX } from "lucide-react";

export const ResultReview = ({ results }) => (
  <div className="flex flex-col gap-3" data-testid="result-review">
    {results.map((r, i) => (
      <div key={i} data-testid={`result-item-${i}`} className={`rounded-2xl border p-4 ${r.correct ? "border-emerald-200 bg-emerald-50/50" : "border-rose-200 bg-rose-50/50"}`}>
        <div className="flex gap-3">
          {r.correct ? <CircleCheck className="text-emerald-600 shrink-0" size={20} /> : <CircleX className="text-rose-600 shrink-0" size={20} />}
          <div className="text-sm">
            <p className="font-semibold text-slate-900">{r.audio_text ? `"${r.audio_text}"` : r.prompt}</p>
            {!r.correct && (
              <p className="text-slate-700 mt-1">
                You said <span className="line-through text-rose-700">{r.your_answer?.trim() || "(skipped)"}</span>, answer: <b className="text-emerald-700">{r.answer}</b>
              </p>
            )}
            {r.explanation && <p className="text-slate-500 mt-1">{r.explanation}</p>}
          </div>
        </div>
      </div>
    ))}
  </div>
);
